import { emit } from '@/custom/classes/my_utils.js'
class TextsHelper {
  getTextByDesignator (texts, designator) {
    for (let i = 0; i < texts.length; i++) {
      let text = texts[i]
      if (text.designator == designator) {
        return text
      }
    }
  }

  isBoldProblem (text) {
    let splitted_text = text.split('^^')
    if (splitted_text.length % 2 == 1) {
      return false
    }
    return true
  }

  makeBold (text) {
    return '<b>' + text + '</b>'
  }

  makeContentBold (text) {
    if (text == undefined) {
      return ''
    }
    let splitted_text = text.split('^^')
    if (this.isBoldProblem(text)) {
      return 'problem'
    }
    let bolded = ''
    for (var i = 0; i < splitted_text.length; i++) {
      if (i % 2 == 1) {
        bolded = bolded + this.makeBold(splitted_text[i])
        continue
      }
      bolded = bolded + splitted_text[i]
    }
    return bolded
  }

  getBoldContent (text, designator) {
    let content = this.makeContentBold(text)
    if (content == 'problem') {
      emit('show_toast', { text: 'יש שגיאה ב- ' + designator + '\nאנא בדק/י שסגרת נכון את אחת מהמילים ב- "^^"' })
      return 'problem'
    }
    return content
  }

  getContent (text) {
    return text != undefined && text.content != undefined ? text.content : ''
  }
}

export default TextsHelper
